type Row = (label: string, value: string, cls?: string) => string;
const fields = ['contractPrice', 'laborPart', 'laborPaid', 'materialPaid', 'materialBilled', 'materialAdvanceGap',
  'contractOut', 'contractIn', 'netContractOut', 'opening', 'totalIn', 'totalOut', 'balance', 'balanceDifference'] as const;

/** 分币转元全程用整数;原始JSON也保留字符串,大额账目不经过Number舍入。 */
export function projectFenMoney(value: string): string {
  const n = BigInt(value), a = n < 0n ? -n : n;
  return `${n < 0n ? '−' : ''}${(a / 100n).toLocaleString('en-US')}.${(a % 100n).toString().padStart(2, '0')} 元`;
}

/** 老引擎缺这组数据时交给原来的钱页显示,不把未知累计付款补成0。 */
export function renderProjectSettlement(value: unknown, row: Row): string | null {
  if (!value || typeof value !== 'object') return null;
  const s = value as {schema?: unknown; contractState?: unknown; fen?: unknown};
  if (s.schema !== 'project-settlement-v1' || !['recorded', 'unrecorded', 'unsigned'].includes(s.contractState as string) || !s.fen || typeof s.fen !== 'object') return null;
  const f = s.fen as Record<string, unknown>;
  if (!fields.every(k => typeof f[k] === 'string' && /^-?\d{1,40}$/.test(f[k] as string))) return null;
  const text = (k: typeof fields[number]) => projectFenMoney(f[k] as string);
  const gap = BigInt(f.materialAdvanceGap as string);
  const current = s.contractState === 'recorded' ? row('当前合同价', text('contractPrice')) +
    row('合同工钱及管理费', `已付 ${text('laborPaid')} / ${text('laborPart')}`) +
    row('当前合同料款已付', text('materialPaid')) + row('当前合同进场计价', text('materialBilled')) +
    (gap > 0n ? row('预支尚未抵进场计价', text('materialAdvanceGap')) : gap < 0n ? row('进场计价超过料款', projectFenMoney((-gap).toString())) : '') :
    s.contractState === 'unsigned' ? row('合同', '尚未签约') : row('开局前合同', '未记录');
  const scope = s.contractState === 'unrecorded' ? '建城后' : '账内累计';
  return current + row(`${scope}工程款付出`, text('contractOut')) +
    (BigInt(f.contractIn as string) !== 0n ? row(`${scope}工程款流入`, text('contractIn')) + row(`${scope}工程款净付出`, text('netContractOut')) : '') +
    row('监管户期初资金', text('opening')) + row('监管户累计到账', text('totalIn')) +
    row('监管户累计转出', text('totalOut')) + row('监管户余额', text('balance')) +
    (BigInt(f.balanceDifference as string) !== 0n ? row('监管账差', text('balanceDifference'), 'bad') : '');
}
